
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface StudentBasicFormProps {
  formData: {
    name: string;
    class: string;
    email: string;
    phone: string;
    default_billing_type?: 'per_session' | 'monthly';
  };
  onFormDataChange: (field: string, value: string) => void;
}

export const StudentBasicForm = ({ formData, onFormDataChange }: StudentBasicFormProps) => {
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="name">Nombre completo *</Label>
        <Input
          id="name"
          value={formData.name}
          onChange={(e) => onFormDataChange('name', e.target.value)}
          placeholder="Ej. María González López"
          required
        />
      </div>

      <div>
        <Label htmlFor="class">Clase *</Label>
        <Input
          id="class"
          value={formData.class}
          onChange={(e) => onFormDataChange('class', e.target.value)}
          placeholder="Ej. 6º A, 1º ESO B..."
          required
        />
      </div>

      <div>
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          value={formData.email}
          onChange={(e) => onFormDataChange('email', e.target.value)}
          placeholder="estudiante@ejemplo.com"
        />
      </div>

      <div>
        <Label htmlFor="phone">Teléfono</Label>
        <Input
          id="phone"
          type="tel"
          value={formData.phone}
          onChange={(e) => onFormDataChange('phone', e.target.value)}
          placeholder="666 123 456"
        />
      </div>

      <div>
        <Label htmlFor="default_billing_type">Tipo de facturación por defecto</Label>
        <Select
          value={formData.default_billing_type || 'monthly'}
          onValueChange={(value) => onFormDataChange('default_billing_type', value)}
        >
          <SelectTrigger>
            <SelectValue placeholder="Selecciona el tipo de facturación" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="monthly">Mensual (cuota fija)</SelectItem>
            <SelectItem value="per_session">Por día (según asistencias)</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
